import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getBidPlacedList,
  getBidReceivedList,
  getPastList,
} from "../../Services/ApiCalling/pastList";

export const fetchAllPastListing = createAsyncThunk(
  "past/get",
  async ({ token, payload, user }) => {
    try {
      let response = await getPastList(token, payload, user);
      return response?.data?.data || [];
    } catch (err) {
      throw err;
    }
  },
);

export const fetchBidPlacedList = createAsyncThunk(
  "past/fetchBidPlacedList",
  async ({ token, connectId, user }, { rejectWithValue }) => {
    try {
      let response = await getBidPlacedList(token, connectId, user);
      return response?.data || {};
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const fetchBidReceivedList = createAsyncThunk(
  "past/fetchBidReceivedList",
  async ({ token, connectId, user }, { rejectWithValue }) => {
    try {
      let response = await getBidReceivedList(token, connectId, user);
      return response?.data || {};
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const pastSlice = createSlice({
  name: "past",
  initialState: {
    pastRecords: [],
    loading: false,
    error: null,
    bidPlacedRecords: [],
    bidReceivedRecords: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllPastListing.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllPastListing.fulfilled, (state, action) => {
        state.loading = false;
        state.pastRecords = action.payload || [];
      })
      .addCase(fetchAllPastListing.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchBidPlacedList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBidPlacedList.fulfilled, (state, action) => {
        state.loading = false;
        state.bidPlacedRecords = action.payload || {};
      })
      .addCase(fetchBidPlacedList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchBidReceivedList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBidReceivedList.fulfilled, (state, action) => {
        state.loading = false;
        state.bidReceivedRecords = action.payload || {};
      })
      .addCase(fetchBidReceivedList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default pastSlice.reducer;
